import { useSearchParams } from 'react-router';
import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import useAuth from '../hooks/useAuth/useAuth';
import { useImpersonateUserMutation } from '../mutations/__generated__/impersonateUser.generated';
import { commonSnackbarPropsAtom } from '../common/state/state';

export default function ImpersonatePage(): React.JSX.Element {
  const [searchParams] = useSearchParams();
  const { setImpersonationToken, logout } = useAuth();
  const [impersonateUser, { data: impersonateUserTokenData, error }] = useImpersonateUserMutation();
  const setCommonSnackbarProps = useSetAtom(commonSnackbarPropsAtom);
  const { t } = useTranslation(['error']);
  const token = searchParams.get('token');
  const contextId = searchParams.get('contextId');

  useEffect(() => {
    if (token) {
      impersonateUser({
        variables: {
          token,
        },
      });
    }
  }, []);

  useEffect(() => {
    const accessTokensData = impersonateUserTokenData?.impersonateUser;
    if (accessTokensData) {
      localStorage.setItem('contextId', contextId!);
      setImpersonationToken(accessTokensData);
    }
  }, [impersonateUserTokenData]);

  useEffect(() => {
    if (error) {
      setCommonSnackbarProps({
        label: t('error:an_error_occured'),
        snackbarProps: {
          open: true,
        },
        alertProps: {
          severity: 'error',
        },
      });
      logout();
    }
  }, [error]);

  return (
    <CircularProgress />
  );
}
